(ns ui.components.search-selector.view
  (:require
   [common.util :as cu]
   [frontend.conn :as conn]
   [potpuri.core :refer [fn->]]
   [promesa.core :as p]
   [reagent.core :as r]
   [ui.editors.labelled-input.view :as labelled-input]
   [ui.components.search-selector.components.searchbox :as searchbox]
   [ui.components.loading-spinner.view :as spinner]
   [ui.util :as uu]))

(def timeouts
  (atom {}))

(defn debounce
  [f id ms]
  (fn [& args]
    (let [t (get @timeouts id)]
      (when t
        (swap! timeouts dissoc id)
        (js/clearTimeout t))
      (swap! timeouts
             assoc
             id (js/setTimeout
                 (fn []
                   (swap! timeouts dissoc id)
                   (apply f args))
                 ms))
      nil)))

(defn search-error
  [{:keys [_state ]} resp]
  ;;TODO allow user to pass on-error
  (println "Error:" resp))

(defn clean-os-results
  [response]
  (->> response
       :body
       :responses
       (into
        []
        (comp
         (mapcat (fn-> :hits :hits))
         (filter :_id)
         (cu/distinct-by :_id)
         (map (fn [{:keys [_id _source] :as hit}]
                (assoc hit
                       :id (parse-long _id)
                       :title (-> _source
                                  :extras
                                  :full-name))))))))

(defn search-success
  [{:keys [query query* results-query* results*
           query-loading*]} response]
  (let [current-query @query*
        results (clean-os-results response)]
    (reset! results-query* query)
    (when (= current-query query)
      (reset! query-loading* false))
    (reset! results* results)))

(defn perform-search
  [{:keys [state] :as args} entity-types query fuzzy?]
  (let [body {:query        query
              :fuzzy?       fuzzy?
              :entity-types (vec entity-types)}]
    (-> (conn/sendp! :search/universal-search body 60000 true)
        (p/then (fn [resp]
                  (search-success (assoc args
                                         :query query) resp)))
        (p/catch (fn [resp]
                   (search-error {:state state} resp))))))

(defn view
  [{:keys [searchbox-id state query* expanded?* query-loading* results-query* results*]}]
  (let [state (or state (r/atom {}))
        query* (or query*
                   (r/cursor state [:query]))
        expanded?* (or expanded?*
                       (r/cursor state [:expanded?]))
        results* (or results*
                     (r/cursor state [:results]))
        ;; for keeping track which query the results are from:
        results-query* (or results-query*
                           (r/cursor state [:results-query]))
        query-loading* (or query-loading*
                           (r/cursor state [:query-loading]))
        searchbox-id (or searchbox-id
                         (str (gensym "searchbox")))
        default-on-query-change (debounce
                                 (fn [entity-types val]
                                   (perform-search
                                    {:query* query*
                                     :results-query* results-query*
                                     :query-loading* query-loading*
                                     :results* results*}
                                    entity-types val true))
                                 searchbox-id
                                 300)]
    (fn [{:keys [label value placeholder entity-types
                 mandatory? on-focus search-on-focus?
                 on-query-change on-clear on-blur]}]
      (let [update-query (fn [val]
                           (reset! query* val)
                           (reset! query-loading* true)
                           ;;(on-loading-change true)
                           (if (fn? on-query-change)
                             (on-query-change val)
                             (default-on-query-change entity-types val)))]
        [:div
         {:class (uu/cm "flex flex-col relative gap-1.5")}
         (when label
           [labelled-input/label-elem
            {:label label
             :mandatory? mandatory?}])
         [:div
          {:class (uu/cm "relative")}
          [searchbox/view
           {:dom-id searchbox-id
            :on-focus (fn []
                        (when (fn? on-focus)
                          (on-focus))
                        (when (and search-on-focus?
                                   (nil? @query*))
                          (update-query "")))
            :on-blur on-blur
            :query @query*
            :value value
            :on-change update-query
            :placeholder placeholder}]
          (cond
            @query-loading*
            [:div
             {:class (uu/cm
                      "absolute right-8 top-3")}
             [spinner/circle]]

            value
            [:div
             {:class (uu/cm
                      "absolute right-8 mr-3 top-3 cursor-pointer")
              :on-click (fn [_]
                          (when (fn? on-clear)
                            (on-clear)))}
             [:i
              {:class (uu/cm "fal fa-times")}]])
          [:div
           {:class (uu/cm
                    "absolute right-4 top-3 cursor-pointer")
            :on-click (fn []
                        (when (and (nil? @query*)
                                   (not @expanded?*))
                          (update-query ""))
                        (swap! expanded?* not))}

           (if @expanded?*
             [:i.fal.fa-angle-up]
             [:i.fal.fa-angle-down])]]]))))
